var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1818_1585",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1818_1585",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACNklEQVR4nO3dwUrDQBSF4bvTR7DR53AnuHLjs6g7xwcU1J0+i0rM6shIFqUMNLGdkzs35wM3MlOS35DiLTRmIiIiIs0AcArgAcAbgC+07wvAK4B7ACfmAYALAB+I6z2fo4crOXLk7djLXdnj7WIt7pYMne/Ja/GyZOhPrMfnkqFXxRSaQ6FJFJpEoUkUmsR76AHAI4Bu/Enj7/auJxz/lONpJnQq7Etz1hPOI0UIvSnsO5uznnAeZxFCd4V953PWE87jPOqt42nOesJ5PEUIPYz3wDlvhn/rCccf6s0wDIUmUWgShSZRaBKFJlFoEoUmUWgS76EHjUk5oVNhn8akFUJvCvs0Jq0Quivs05i0QuhU2KcxaYXQg8aknNBhHNpLoSdSaBKFJlFoEoUmUWgShSZRaBLvoQeNSTmhU2GfxqQVQm8K+zQmrRC6K+zTmLRC6FTYpzFphdCDxqSc0GEc2kuhJ1JoEoUmUWgShSZRaBKFJlFoklWPSXGk19l6vWsA3y2GTjXHpMd6nX2R8x/OGpzedXPW//MYjnYlj55tKZ5D23Ej9wAubc1jUhwYemLkG1uShzEpDgjdROTxQN2y/cd+teebKH8A3JoHcMyiRM7gmEWJnMExixI5g2MWJXIGxyxK5AyOWZTIGRyzKJEz+HYVInIDXz3/7f4/vuAPU+ibipyNT95pSd9c5Cw/BGZ8GEwL+iYj7zzCyXvsvunIO1f2XX4ojLM3yCF/MrLo0F5ERETEmH4BGinWMcPOOGwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.0a045ffdca3c739ecb85e81570b35c31.svg";
export { ForwardRef as ReactComponent };